import React from "react";

const Migration = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill} fillRule="evenodd" d="M10.585 7v5.525h9.318V14.6H8.543v-2.516l-3.67 3.806 3.67 3.728v-2.294H25.52v-4.97L34 20.973l-8.48 8.25v-4.764h-9.191v-2.076h11.233v1.98l3.518-3.422-3.518-3.575v2.034H10.585v5.229L2 15.905 10.585 7Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Migration;